import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const DemoGate: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@') || !email.includes('.')) {
      setError('Please enter a valid work email address.');
      return;
    }
    localStorage.setItem('bm_demo_email', email);
    navigate('/see-a-demo/library');
  };

  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ background: 'linear-gradient(135deg, #241E61 0%, #1B2B4B 100%)' }}>
        <div className="max-w-md w-full text-center">
          {/* Logo */}
          <div className="mb-12">
            <img src="/img/logo-full.png" alt="BrandedMark" className="h-10 mx-auto" onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }} />
            <div className="mt-2 text-white/40 text-sm font-medium tracking-wider uppercase">Interactive Demo</div>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-4">
            See BrandedMark in Action
          </h1>
          <p className="text-lg text-white/70 mb-10">
            Explore how leading brands use BrandedMark to deliver digital product experiences — from first scan to end of life.
          </p>

          {/* Trust badge */}
          <div className="mb-8 inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 text-white/80 text-sm">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
            Trusted by brands across eBike, fitness, and industrial equipment
          </div>

          {/* Email form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                placeholder="Work email address"
                className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-[#00B37E] focus:border-transparent text-base"
                autoComplete="email"
              />
              {error && <p className="mt-2 text-sm text-red-300">{error}</p>}
            </div>
            <button
              type="submit"
              className="w-full px-6 py-3 rounded-lg font-semibold text-white text-base transition-opacity hover:opacity-90"
              style={{ background: 'linear-gradient(90deg, #00B37E 0%, #00D084 100%)' }}
            >
              Explore the Demo
            </button>
          </form>

          {/* Below fold bullets */}
          <div className="mt-12 text-left space-y-3">
            {[
              'Experience the product scan journey your customers will see',
              'See passkey-powered ownership registration in action',
              'Explore a live EU Digital Product Passport'
            ].map((text, i) => (
              <div key={i} className="flex items-start gap-3 text-white/60 text-sm">
                <svg className="w-5 h-5 text-[#00B37E] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                {text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
